(function () {
  window.JS_SCRIPTS_LOADED = {};

  var loadJS = function (jsFile, element, onLoadName, mode) {
    var mode = mode || 'async';
    if (jsFile === "" || window.JS_SCRIPTS_LOADED[jsFile] === true) {
      return;
    }

    if (element) {
      // So you can add extra styles when this is entered if needed.
      element.dataset.entered = true;
    }

    window.JS_SCRIPTS_LOADED[jsFile] = true;
    var script = document.createElement("script");
    script.src = jsFile;

    if(mode = 'async') {
      script.async = true;
    } else {
      script.defer = true;
    }

    script.dataset.isLazyJS = true;

    if (onLoadName && typeof window[onLoadName] === "function") {
      script.onload = function () {
        window[onLoadName]();
      };
    }
    document.body.appendChild(script);
  };

  function initLazyScripts() {
    var lazyScripts = document.querySelectorAll("[data-lazy-js]");

    if (lazyScripts.length === 0) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          var jsFile = entry.target.dataset.lazyJs;
          loadJS(jsFile, entry.target);
        }
      });
    });

    document.querySelectorAll("[data-lazy-js]").forEach((element) => {
      observer.observe(element);
    });
  }

  function initDOMLoadedScripts() {
    document
      .querySelectorAll("script[type='lazy/onLoad']")
      .forEach(function (script) {
        loadJS(script.dataset.src, null, script.dataset.load, script.dataset.mode || 'async');
      });

    document
      .querySelectorAll("script[type='lazy/onIntersect']")
      .forEach(function (script) {
        const load = loadJS.bind(null, script.dataset.src, null, script.dataset.load, script.dataset.mode || 'async')

        const triggers = script.dataset.trigger ? [...document.querySelectorAll(script.dataset.trigger)] : [script]
        const offset = script.dataset.offset || 300

        const onIntersect = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.debug(`Lazy script intersection detected. Loading "${script.dataset.src}"...`)
              load()
              observer.disconnect()
            }
          })
        }

        const observer = new IntersectionObserver(onIntersect, {
          rootMargin: `0px 0px ${offset}px 0px`,
        })

        for (const trigger of triggers) {
          observer.observe(trigger)
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initLazyScripts();
      initDOMLoadedScripts();
    });
  } else {
    initLazyScripts();
    initDOMLoadedScripts();
  }
})();
